import { render, staticRenderFns } from "./RelatedPlayList.vue?vue&type=template&id=32ee58ae&scoped=true&"
import script from "./RelatedPlayList.vue?vue&type=script&lang=js&"
export * from "./RelatedPlayList.vue?vue&type=script&lang=js&"
import style0 from "./RelatedPlayList.vue?vue&type=style&index=0&id=32ee58ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ee58ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ee58ae')) {
      api.createRecord('32ee58ae', component.options)
    } else {
      api.reload('32ee58ae', component.options)
    }
    module.hot.accept("./RelatedPlayList.vue?vue&type=template&id=32ee58ae&scoped=true&", function () {
      api.rerender('32ee58ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/common/components/RelatedPlayList.vue"
export default component.exports